import React from 'react';
import PropTypes from "prop-types";

function MobileView({children, flexDirection = 'column', flexWrap = false, alignContent, justifyContent='flex-start', alignItems='center', style={}}){
    let wrap = 'nowrap';
    if (flexWrap) wrap = 'wrap';
    let innerWidth = `${window.innerWidth}px`;
    let innerHeight = `${window.innerHeight}px`;
    let customStyle = style;

    if (!customStyle.display) customStyle.display = 'flex';
    if (!customStyle.wrap) customStyle.wrap = wrap;
    if (!customStyle.flexDirection) customStyle.flexDirection = flexDirection;
    if (!customStyle.alignContent) customStyle.alignContent = alignContent;
    if (!customStyle.justifyContent) customStyle.justifyContent = justifyContent;
    if (!customStyle.alignItems) customStyle.alignItems = alignItems;
    if (!customStyle.width) customStyle.width = innerWidth;
    if (!customStyle.height) customStyle.height = innerHeight;


    return (
        <div className='mobileView' id='mobileViewContainer' style = {customStyle}>
            {children}
        </div>
    )
}

MobileView.propTypes = {
    flexDirection: PropTypes.string,
    flexWrap: PropTypes.bool,
    alignContent: PropTypes.string,
    justifyContent: PropTypes.string,
    alignItems: PropTypes.string,
    style: PropTypes.object
}

export default MobileView;